module.exports = __webpack_public_path__ + "media/7.9348b10b.mp3";